/* App footer */

import * as React from 'react';

import * as AppComp from '../common/app-component-base';
import * as ReduxQueries from '../queries';
import AppConfiguration from '../config/configuration';

export interface INavProps {
  branding?: any;
}

export default class Footer extends React.Component<INavProps, any> {
  public constructor(props: INavProps) {
    super(props);
  }

  public render() {
    let buildTarget;
    const environmentTarget = AppConfiguration.getEnvironmentTarget();

    if (environmentTarget) {
      buildTarget = (
        <div>
          <span className="text-muted">{environmentTarget}</span>
        </div>
      );
    }

    const { branding, ...rest } = this.props;

    return (
      <footer className="footer text-center">
        <span className="text-muted">&copy; {branding.copyrightYears} {branding.companyName}</span>
        {buildTarget}
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/footer/index.tsx